import { get } from 'lodash';
import { call, fork, put, take, select } from 'redux-saga/effects';

import {
	BULK_REFUNDS_REQUESTING,
	BULK_REFUNDS_SUCCESS,
	BULK_REFUNDS_ERROR,
	UPLOAD_TRANSACTION_LIST_ERROR,
	UPLOAD_TRANSACTION_LIST_REQUESTING,
	UPLOAD_TRANSACTION_LIST_SUCCESS,
} from '@/redux/ducks/bulkRefunds/types';
import Api from '@/data';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';

export const getBulkRefundFilters = (state) => state.bulkRefunds.filters;

export function* fetchBulkRefund(payload) {
	try {
		yield put({
			type: BULK_REFUNDS_REQUESTING,
			payload,
		});
		const response = yield call(Api.getBatchRefunds, payload);
		yield put({
			type: BULK_REFUNDS_SUCCESS,
			data: response.data,
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: BULK_REFUNDS_ERROR, error: error.data });
		}
	}
}

export function* getBulkRefundsList() {
	while (true) {
		const action = yield take(BULK_REFUNDS_REQUESTING);
		yield call(fetchBulkRefund, action.payload);
	}
}

export function* uploadTransactionList(payload) {
	try {
		yield put({
			type: UPLOAD_TRANSACTION_LIST_REQUESTING,
		});
		const response = yield call(Api.uploadBatchFile, payload);
		yield put({
			type: UPLOAD_TRANSACTION_LIST_SUCCESS,
		});
		if (response.data.success) {
			yield put({
				type: SHOW_TOAST,
				payload: { msg: 'Transaction List uploaded.', type: 'success' },
			});
			// Reload bulk transaction list with stored filters
			const bulkRefundFilter = yield select(getBulkRefundFilters);
			yield put({ type: BULK_REFUNDS_REQUESTING, payload: bulkRefundFilter });
		} else {
			yield put({
				type: SHOW_TOAST,
				payload: {
					msg: 'Transaction List not uploaded. Incorrect File or Format.',
					type: 'error',
				},
			});
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: UPLOAD_TRANSACTION_LIST_ERROR, error: error.data });

			yield put({
				type: SHOW_TOAST,
				payload: {
					msg: get(error, 'data.message') || 'Incorrect File or Format.',
					type: 'error',
				},
			});
		}
	}
}

export function* uploadTransactionListWatcher() {
	while (true) {
		const action = yield take(UPLOAD_TRANSACTION_LIST_REQUESTING);
		yield call(uploadTransactionList, action.payload);
	}
}

function* bulkRefundsFlowSaga() {
	yield fork(getBulkRefundsList);
	yield fork(uploadTransactionListWatcher);
}

export default bulkRefundsFlowSaga;
